enum ComponentType {
  HEADING = 1,
  IMAGE = 2,
  DIVIDER = 3,
  TEXT = 4,
  SLIDESHOW = 5,
  VIDEO = 6
}

export default ComponentType;
